export default __webpack_public_path__ + "static/icp-ent-banner-9ccde32b8ba33305b21249fe4d078b76.png";